import React from "react";
import FeatureTop from "./FeatureTop";
import FeatureBottom from "./FeatureBottom";


function MainFeatures() {
    return (
        <>
            <FeatureTop/>
            <FeatureBottom/>
        </>
    );
}

export default MainFeatures;
